<template>
  <div class="download">
    <img src="./img/top-download.svg" alt="">
    <transition name="el-zoom-in-top">
        <div class="qr-box">
            <div class="bg">
                <vue-qr
                    class="codeQr"
                    :margin="0"
                    colorDark="#000"
                    colorLight="#fff"
                    :text="downloadData[0].url"
                    :logoScale="0.2"
                    :size="81"
                ></vue-qr>
            </div>
        </div>
    </transition>
  </div>
</template>

<script>
import VueQr from "vue-qr";
import { mapState } from "vuex";
export default {
    components: { VueQr },
    data(){
        return{
            dialogDown:false
        }
    },
    computed:{
        downloadData() {
          return [{ url: this.appJump }];
        },
         ...mapState({
            appJump: (state) => state.linkList.appJump,
        }),
    }
}
</script>

<style lang="scss" scoped>
.download{
    padding-right:15px;
    cursor: pointer;
    position: relative;
    &:hover{
        .qr-box{
            display: flex;
        }
    }
    .qr-box{
        display: none;
        position: absolute;
        border-radius: 16px;
        background: linear-gradient(118.88deg, #474747 0%, #323631 100%);
        width:113px;
        height:113px;
        // display: flex;
        align-items: center;
        left:-78px;
        top:50px;
        transition: all .3s;
        z-index:10;
        .bg{
            width:100px;
            height:100px;
            line-height:100px;
            background-color: #fff;
            border-radius:16px;
            margin: 0 auto;
        }
        .codeQr{
            width:81px;
            margin: 0 auto;
            border-radius:16px !important;
            img{
                border-radius:16px !important;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/build902/components/common/appDownload2.vue